import classNames from 'classnames';
import styles from './index.module.sass';

export const TopSwitcher = ({
  activeTab,
  setActiveTab,
}: {
  activeTab: number;
  setActiveTab: (val: 2 | 1 | 0) => void;
}) => {
  return (
    <div className={styles.root}>
      <div className={styles.elem}>
        <span
          onClick={() => setActiveTab(0)}
          className={classNames(activeTab === 0 && styles.active)}
        >
          предложения покупателей
        </span>
        <span
          onClick={() => setActiveTab(1)}
          className={classNames(activeTab === 1 && styles.active)}
        >
          поиск зерна по заданным параметрам
        </span>
        <span
          onClick={() => setActiveTab(2)}
          className={classNames(activeTab === 2 && styles.active)}
        >
          поиск в диапазоне
        </span>
      </div>
    </div>
  );
};
